// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1G-Vz","content":"RecentSearches_content__1jFYT"};